import Api from "./api";

class AgateProjectApi {
	static get = () => {
		const url = `agateprojects`;
		return Api
			.get(url)
			.then(response => {
				return response.data;
			});
	};
	
}

export default AgateProjectApi;